export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const uid = () => typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

// ---------- PRODUCT TAB ----------
export const COMPANY_TYPES = [
  { id: "asset_led",         label: "Asset-led" },
  { id: "platform_led",      label: "Platform-led" },
  { id: "hybrid",            label: "Hybrid: lead asset + platform upside" },
  { id: "service_tool_led",  label: "Service / tool-led" },
  { id: "data_led",          label: "Data-led" },
  { id: "unsure",            label: "Unsure" },
];

export const DEFAULT_COMPONENT_ROWS = [
  "Biology / target insight",
  "Modality / product format",
  "Discovery method",
  "Data / datasets",
  "Assays / models",
  "Lead asset",
  "Biomarker / patient-selection logic",
  "Manufacturing process",
  "Platform repeatability",
  "Partnerable package",
];

export const CORE_TO_VALUE = ["Yes", "No", "Partly", "Unknown"];
export const OWNERSHIP_OPTIONS = ["Owned", "Licensed", "Partner-dependent", "Public / open", "Not yet controlled", "Unknown"];
export const MATURITY_OPTIONS = ["Low", "Medium", "High"];
export const REPLACEABLE_OPTIONS = ["Yes", "No", "Difficult", "Unknown"];

// ---------- DEFENSIBILITY TAB ----------
export const PROTECTION_TYPES = ["Patent", "Patent application planned", "Licensed IP", "Trade secret", "Know-how", "Data advantage", "Algorithm/software", "Brand", "Exclusive access", "Collaboration agreement", "Open-source / third-party dependency", "No protection yet", "Unknown"];
export const OWNERSHIP_CONTROL = ["Owned by us", "Licensed", "University-owned", "Founder-owned", "Partner-owned", "Public/open", "To be negotiated", "Unknown"];
export const RISK_LEVELS = ["Low", "Medium", "High", "Unknown"];
export const SCORE_LEVELS = ["Strong", "Medium", "Weak", "Unknown"];

export const SCORE_DIMENSIONS = [
  { id: "copy_ease",         label: "Hard to copy?" },
  { id: "protect",           label: "Can we protect it?" },
  { id: "secret",            label: "Can we keep it secret?" },
  { id: "own",               label: "Can we prove ownership?" },
  { id: "fto",               label: "Can we operate without infringing?" },
  { id: "matters_to_pharma", label: "Would pharma/investors care?" },
];

// ---------- VALUE CAPTURE TAB ----------
export const VALUE_CAPTURE_ROUTES = [
  "Out-license lead asset",
  "Option-to-license deal",
  "Co-development partnership",
  "Platform discovery collaboration",
  "Multi-target pharma partnership",
  "Service revenue / paid discovery work",
  "Build internal pipeline",
  "Asset sale / acquisition",
  "Hybrid model",
  "Unsure",
];
export const MONETISABLE_UNITS = [
  "One lead asset",
  "Multiple assets",
  "Platform access",
  "Target discovery collaboration",
  "Data package",
  "Therapeutic product",
  "Service project",
  "Option rights",
  "Licence",
  "Acquisition",
  "Other",
];
export const REVENUE_TYPES = ["Upfront payment", "Milestones", "Royalties", "Research funding", "Non-recurring engineering / funded collaboration", "Service revenue", "Equity investment", "Acquisition", "Grant/non-dilutive funding", "Unknown"];

export const DEFAULT_REVENUE_ROWS = [
  "Asset licence", "Platform collaboration", "Internal pipeline", "Service/funded collaboration", "Acquisition",
];

// ---------- CAUTIONARY TALES ----------
export const CAUTIONARY_TALES = {
  product: {
    title: "Platform without proof",
    body: "Many startups pitch a platform before proving that it can generate more than one credible asset. Investors and pharma often ask: what is the repeatable engine, and what is the proof-point asset?",
    lesson: "Separate the lead asset story from the platform story. Make clear what is reusable, what is asset-specific, and what evidence proves repeatability.",
  },
  defensibility: {
    title: "Disclosure before protection",
    body: "Early scientific excitement can lead teams to disclose targets, methods, data or molecule details before the protection strategy is clear. This can weaken future patentability, partnering leverage or competitive advantage.",
    lesson: "Before talking widely, decide what can be shared, what needs protection, and what requires NDA or expert review.",
  },
  value_capture: {
    title: "Platform story, asset economics",
    body: "Many therapeutic startups describe themselves as platforms but raise money or partner around a single lead asset. This is not wrong, but it creates confusion if the proof, IP and revenue model do not align.",
    lesson: "Be explicit: are you selling an asset, platform access, repeatable discovery capability, or a hybrid story?",
  },
};

// ---------- SEVERITY COLORS ----------
export const SEVERITY_STYLES = {
  high:   "bg-red-50 text-red-800 border-red-200",
  medium: "bg-amber-50 text-amber-800 border-amber-200",
  low:    "bg-slate-50 text-slate-700 border-slate-200",
};
